<template>
    <div 
        @click.stop="toogleSelect"
        :class="[
            ' o-language-selector-no language-selector',
            isOpenSelect ? 'active' : ''
        ]"
        v-click-outside="closeSelect"
    >
        <transition-group 
            class="language-selector-list"
            name="flip-list" 
            tag="ul"
        >
            <div 
                :class="[
                    'language-selector-list__item',
                    lang.value == getActiveLocale ? 'active' : ''
                ]"
                v-for="lang in sortedDropdownOptions"
                :key="lang.value"
                @click.stop="handleChangeLocale(lang.value)"
            >
                <div class="language-selector-list__item-label-wrapper">
                    <svg-icon
                        original
                        :name="`locales/${lang.value}-circle`"
                        class="language-selector-list__item-icon"
                    />
                    <span 
                        class="language-selector-list__item-label"
                    >
                        {{lang.lable}}
                    </span>
                </div>
                <div class="language-selector-list__item-line"></div>
            </div>
        </transition-group>
        <svg-icon
            @click.stop="toogleSelect"
            original
            name="icons/arrow-down-3"
            class="language-selector__arrow"
        />
    </div>
    <!-- <ADropdown
        v-model="locale"
        :items="dropdownOptions"
        :style="commonConfigStyles"
        :isPrefix="true"
        isShowSelectDropdownIcon
        localeIconSuffics="-circle"
        key-field="value"
        class="o-language-selector-no"
        @onChange="handleChangeLocale"
    >
        <template #select-option="{ option }">
            <div class="dropdown__inner-block">
                <svg-icon
                    original
                    :name="`locales/${option.value}`"
                    class="dropdown__icon"
                />
            </div>
        </template>
    </ADropdown> -->
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters 
} from "vuex";

import {
    SHOW_OVERLAY,
    RESTORE_LOCALE
} from "@/utils/constants/bus-events-constants";

import vClickOutside from 'v-click-outside'

export default {
    name: 'OLanguageSelectorNO',
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            locale: this.$i18n.locale(),
            isOpenSelect: false
        }
    },
    computed: {
        ...mapState({
            languages: state => state.map.meta.languages,
            defaultLocale: state => state.map.meta.language
        }),
        ...mapGetters([
            'getActiveLocale',
            'getMapConfigProp'
        ]),
        dropdownOptions() {
            if(this.componentParams.languages) {
                return this.componentParams.languages
            }
            const result = [];
            this.languages.forEach(item => {
                result.push({
                    value: item,
                    label: this.$t(`ui.language-${item}`)
                })
            });
            return result;
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OLanguageSelectorNO.styles') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.header.OLanguageSelectorNO.params`) || {};
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OLanguageSelectorNO.params') || {};
        },
        componentParams() {
            return {
                ...this.viewConfigParams,
                ...this.commonConfigParams
            }
        },
        sortedDropdownOptions() {
            const newArr = [];
            this.dropdownOptions.forEach(item => {
                if(item.value == this.getActiveLocale) {
                    newArr.unshift(item)
                } else {
                    newArr.push(item)
                }
            })
            return newArr
        }
    },
    mounted() {
        this.locale = this.getActiveLocale;
        this.initEventsListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        ...mapActions([
            'changeLocale'
        ]),
        initEventsListeners() {
            this.$bus.$on(RESTORE_LOCALE, this.restoreLocale);
        },
        deactivateEventsListeners() {
            this.$bus.$off(RESTORE_LOCALE, this.restoreLocale);
        },
        handleChangeLocale(locale) {
            if(locale == this.getActiveLocale) {
                this.toogleSelect()
            } else {
                this.changeLocale(locale);
            }
        },
        handleOpenClose() {
            this.$bus.$emit(SHOW_OVERLAY, true);
        },
        restoreLocale() {
            this.changeLocale(this.defaultLocale);
            this.locale = this.defaultLocale;
            this.closeSelect()
        },
        toogleSelect() {
            this.isOpenSelect = !this.isOpenSelect
        },
        closeSelect() {
            this.isOpenSelect = false
        }
    }
}
</script>
<style lang="scss" src="./theme.scss" />